import React, { useState, useRef } from "react";
import { motion, useMotionValue } from "framer-motion";
import FeedbackStepLayout from "../FeedbackStepLayout";

const Step3Confidence = ({ data, updateData, nextStep, prevStep }) => {
  const barRef = useRef(null);
  const [progress, setProgress] = useState(data.learningLevel || 0.5);
  const x = useMotionValue(0);

  const handleDrag = (event, info) => {
    if (!barRef.current) return;
    const rect = barRef.current.getBoundingClientRect();
    const offset = Math.min(Math.max(info.point.x - rect.left, 0), rect.width);
    setProgress(offset / rect.width);
  };

  const handleNext = () => {
    updateData("learningLevel", progress);
    nextStep();
  };

  const percent = Math.round(progress * 100);

  return (
    <FeedbackStepLayout
      title="Give yourself a range"
      subtitle="How much did you learn?"
      step={3}
      totalSteps={5}
      onNext={handleNext}
      onBack={prevStep}
    >
      <div className="flex flex-col items-center mt-10 gap-4 select-none">
        {/* === Track === */}
        <div
          ref={barRef}
          className="relative w-80 h-5 bg-gradient-to-r from-sky-200 to-blue-500 rounded-[5px]"
        >
          {/* Slider Handle */}
          <motion.div
            drag="x"
            dragConstraints={barRef}
            dragElastic={0}
            onDrag={handleDrag}
            style={{
              left: `${progress * 100}%`,
              top: "50%", // keep midpoint anchored on bar
              y: "-50%", // use y offset instead of CSS transform
            }}
            className="absolute w-2.5 h-10 bg-black rounded-sm cursor-pointer shadow-md"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 1.15 }}
          />
        </div>

        {/* === Labels === */}
        <div className="flex justify-between w-80 mt-2">
          <div className="text-neutral-400 text-[10px] font-medium font-['Inter']">zippo</div>
          <div className="text-neutral-400 text-[10px] font-medium font-['Inter']">A lot!</div>
        </div>

        {/* === Feedback === */}
        <div className="text-[12px] text-neutral-600 font-medium mt-4">
          {percent <= 10
            ? "Still warming up..."
            : percent <= 40
            ? "Starting to click!"
            : percent <= 70
            ? "You’re learning well!"
            : percent < 100
            ? "Almost mastered!"
            : "Full sync achieved ⚡️"}
        </div>
      </div>
    </FeedbackStepLayout>
  );
};

export default Step3Confidence;
